<template>
  <v-card tile class="fill-height">
    <v-card-text>
      <div v-if="error">
        <v-alert
          v-for="(e, index) in error.data.errors"
          :key="index"
          color="error"
          dark
          dense
          >{{ e[0] }}
        </v-alert>
      </div>

      <v-row v-if="$can('sensitive-data')" dense>
        <v-col cols="12" class="d-flex justify-right">
          <v-spacer />
          <v-btn dark color="indigo" outlined @click="createPrivateNoteDialog">
            <v-icon left>mdi-plus</v-icon>
            {{ $t('PERSONS.PRIVATE_NOTE') }}
          </v-btn>

          <default-dialog
            v-model="createNoteDialog"
            @cancel="createNoteDialog.dialog = false"
          >
            <template v-slot:card>
              <v-card-text>
                <v-form ref="formPrivate" v-model="validPrivate">
                  <v-textarea
                    v-model="privateNote"
                    :rules="rules.privateNote"
                    :counter="400"
                  />
                </v-form>
              </v-card-text>
            </template>

            <template v-slot:title>
              <v-toolbar-title>
                {{ $t('ITEM.ADD') }}
                {{ $t('PERSONS.PRIVATE_NOTE') }}
              </v-toolbar-title>
            </template>

            <template v-slot:buttons>
              <v-btn
                large
                outlined
                depressed
                color="grey"
                @click.native="createNoteDialog.dialog = false"
              >
                {{ $t('BUTTON.CANCEL') }}
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn
                large
                depressed
                :disabled="!validPrivate"
                color="primary"
                @click.native="createPrivateNote"
              >
                {{ $t('BUTTON.CREATE') }}
              </v-btn>
            </template>
          </default-dialog>
        </v-col>
      </v-row>

      <v-row dense>
        <v-col cols="12">
          <v-form
            ref="form"
            v-model="valid"
            lazy-validation
            @submit.prevent="publish"
          >
            <v-textarea
              v-model="input"
              append-outer-icon="mdi-send"
              rows="1"
              :counter="400"
              :rules="rules.textDescription400"
              :label="$t('PERSONS.NEW_NOTE')"
              @click:append-outer="publish(input, false)"
            />
          </v-form>
        </v-col>
      </v-row>

      <v-list max-height="700" class="pt-0 overflow-y-auto">
        <template
          v-for="(item, index) in localPersonRequests.slice().reverse()"
        >
          <v-list-item :key="item.headline" class="px-0">
            <v-list-item-content>
              <v-list-item-subtitle
                class="text--grey text-wrap"
                v-text="item.text"
              ></v-list-item-subtitle>
            </v-list-item-content>

            <v-list-item-action class="pr-2">
              <v-list-item-action-text
                v-text="item.date"
              ></v-list-item-action-text>
              <v-list-item-subtitle v-if="item.user" class="text-caption">
                <p class="text-right mb-0">
                  {{ item.user.username }}
                </p>
                <p v-if="item.is_private" class="mb-0 mt-1">
                  <v-chip outlined small color="primary">{{
                    $t('PERSONS.PRIVATE_NOTE')
                  }}</v-chip>
                </p>
              </v-list-item-subtitle>
            </v-list-item-action>
          </v-list-item>
          <v-divider :key="index"></v-divider>
        </template>
      </v-list>
    </v-card-text>
  </v-card>
</template>

<script>
import moment from 'moment';
import {
  textDescription400,
  notEmpty
} from '@/modules/_global/variables/rules.js';
import DefaultDialog from '@/modules/_global/_components/DefaultDialog';

export default {
  name: 'NotesPage',
  components: { DefaultDialog },
  model: {
    prop: 'personRequests'
  },

  props: {
    personRequests: {
      type: Array,
      required: true
    },
    personId: {
      type: Number,
      required: true
    }
  },

  data: () => ({
    localPersonRequests: [],
    input: '',
    username: null,
    user: null,
    error: null,
    valid: true,
    validPrivate: true,
    rules: {
      privateNote: [notEmpty, ...textDescription400],
      textDescription400
    },
    createNoteDialog: null,
    privateNote: ''
  }),

  created() {
    this.user = { ...this.$store.getters['auth/user'] };
    this.localPersonRequests = [...this.personRequests];
    // this.localPersonId = this.person_id
  },

  methods: {
    createPrivateNote() {
      this.publish(this.privateNote, true);
    },

    createPrivateNoteDialog() {
      this.createNoteDialog = { dialog: true };
      this.privateNote = '';
    },

    publish(input, is_private) {
      if (input.length) {
        if (this.$refs.form.validate()) {
          this.time = new Date();
          this.username = this.user.username || null;
          this.$store
            .dispatch('person_request/store', {
              person_request: {
                user_id: this.user.id,
                person_id: this.personId,
                is_private: is_private,
                text: input,
                date: moment(this.time).format('YYYY-MM-DD')
              }
            })
            .then(response => {
              this.localPersonRequests.push({
                text: input,
                is_private: is_private,
                date: moment(this.time).format('YYYY-MM-DD'),
                user: this.user
              });
              this.input = null;
              this.createNoteDialog.dialog = false;
            })
            .catch(error => {
              this.$vuetify.goTo(0);
              this.error = error.response;
            });
        }
      }
    }
  }
};
</script>
